module.exports = __webpack_public_path__ + "img/recon_reports.11f07281.svg";